import React, {useMemo, useState} from 'react';
import {withFormsy} from 'formsy-react';
import CreatableSelect from "react-select/creatable";
import Select from 'react-select'

let stylesConfig = TB.reduce(['indicatorContainer', 'control','valueContainer','option', 'input', 'multiValueLabel', 'placeholder', 'noOptionsMessage'], (styleConfig, type) => {
    let componentStyles = {fontSize: 12};
    if (type === 'control') {
        componentStyles.minHeight = 'unset';
        componentStyles.borderColor = 'hsl(0, 0%, 80%)'
    }
    if (type === 'indicatorContainer') {
        componentStyles = {
            padding: 7
        }
    }
    if (type === 'valueContainer') {
        componentStyles.padding = '2px 8px';
    }
    if(type === 'input') {
        componentStyles = {
            ...componentStyles,
            padding: 0,
            margin: 0,
            borderColor: 'none',
            boxShadow: 'none',
        }
    }
    styleConfig[type] = (provided, state) => {
        let typeStyle = {
            ...provided,
            ...componentStyles
        };

        if (state.isFocused && type === 'control') {
            typeStyle = {
                ...typeStyle,
                borderColor: 'hsl(0, 0%, 80%)',
                boxShadow: '0 0 0 1px #4B80E7',
                '&:hover': {borderColor: 'hsl(0, 0%, 80%)'}
            }
        }
        return typeStyle
    };
    return styleConfig
}, {})

const CreatableMultiSelect = ({selectProps = {}, options, canCreate = true, ...props}) => {

    const [inputValue, setInputValue] = useState('');

    const handleInputChange = (value) => {
        setInputValue(value)
    };

    let errorMessage = props.getErrorMessage();

    let className = props.className || '';
    className += props.showRequired() ? ' required ' : '';

    className += !props.isValid() && props.isFormSubmitted() ? ' text-danger' : '';

    const onChange = (values = []) => {
        let selected = TB.map(values, value => TB.pick(value, ['label', 'value']))
        props.setValue(selected);
        if (inputValue?.length) setInputValue('');
    }

    const allAvailableOptions = useMemo(() => {
        let allOptions = [...options];
        if (TB.find(options, 'options')) {
            allOptions = TB.flatten(TB.map(options, 'options'));
        }
        return TB.filter([...allOptions], option => !option.disabled);
    }, [options]);

    const hasSelectedAll = useMemo(() => {
        let selectedAll = true;
        let selected = TB.map([...(props.getValue() || [])], 'value');

        TB.map(allAvailableOptions, option => {
            if (!selected.includes(option.value)) {
                selectedAll = false
            }
        })

        return selectedAll;
    }, [props.value, allAvailableOptions.length]);

    const SelectInput = canCreate ? CreatableSelect : Select;

    return (
        <div className={'form-group react-select-container ' + className}>

            {props.label && (
                <label className={"col-form-label " + (props.labelClassName || '')}>
                    {props.label}
                </label>
            )}

            <div className="flex flex-grow flex-row items-center">
                <SelectInput
                    {...selectProps}
                    isMulti
                    isClearable={false}
                    className="flex-grow"
                    styles={stylesConfig}
                    options={options}
                    menuIsOpen={(!canCreate || (inputValue?.length > 1))? undefined : false}
                    onInputChange={handleInputChange}
                    onChange={onChange}
                    value={props.getValue() || []}
                />

                {props.canSelectAll && (
                    <div style={{flex: 0, paddingLeft: 15}}>
                        <input
                            type="checkbox"
                            className="form-check-input"
                            disabled={props.disabled || !allAvailableOptions.length}
                            name={props.name + "-select-all"}
                            id={props.name + "-select-all"}
                            checked={allAvailableOptions.length && hasSelectedAll}
                            onChange={e => {
                                let selected = [...(props.getValue() || [])];

                                if (e.target.checked) {
                                    selected = TB.uniqBy([...selected, ...allAvailableOptions], 'value');
                                } else {
                                    let currentlySelected = TB.map(allAvailableOptions, 'value');
                                    selected = TB.reject(selected, option => !TB.isString(option?.value) && currentlySelected.includes(option?.value))
                                }
                                return onChange(selected)
                            }}
                        />
                        <label className="form-check-label whitespace-no-wrap" htmlFor={props.name + "-select-all"}>
                            Select All
                        </label>
                    </div>
                )}
            </div>
            {errorMessage && (
                <span className={'invalid-feedback'}>
                    {errorMessage}
                </span>
            )}
        </div>
    );
};

CreatableMultiSelect.propTypes = {};

export default withFormsy(CreatableMultiSelect);